<script setup lang="ts">
// REVIEW See if init() is better handled at page/route level & with only specific preferences
usePreferencesStore().init()

const { locale } = useI18n()
const lang = localeConfig[locale.value]?.languageCode || 'en'
useHead(() => ({ htmlAttrs: { lang } }))

const cnstrcSessionKey = 'constructor-session-init'
if (import.meta.client && !sessionStorage.getItem(cnstrcSessionKey)) {
  sessionStorage.setItem(cnstrcSessionKey, 'true')
  useConstructorTracker().trackSessionStart()
}

// Exit intent detection is sitewide — wired here at the root so it covers all layouts and pages.
// useExitIntent accesses window directly so must be client-side only.
if (import.meta.client) {
  const { $braze } = useNuxtApp()
  const { logCustomEvent } = useBrazeTracking()
  useExitIntent(
    (payload, isImmediateExit) => {
      logCustomEvent('exit_intent', payload)
      $braze.debugLogger(
        `exit_intent logged — reason: ${payload.reason}, path: ${payload.exit_from_path}, cart_items: ${payload.cart_item_count}, has_clearance: ${payload.cart_has_clearance_items}, immediate: ${isImmediateExit}`,
      )
      // A genuine exit needs the standard flush forced, since the default ~10s interval may
      // not run before the tab is frozen/unloaded.
      if (isImmediateExit) {
        $braze.sdk.requestImmediateDataFlush()
      }
    },
    (event, reason) => {
      $braze.debugLogger(`exit_intent ${event} — reason: ${reason}`)
    },
  )
}
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
